import { Event, EventType } from "./Event";

import type { IVisitEvent } from "./types";

export class VisitEvent extends Event {
  constructor({ tracking, customEventProperties }: IVisitEvent) {
    super({
      event_type: EventType.visit,
      event_properties: {
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
